module.exports = __webpack_public_path__ + "img/img-skin03.5ec75bc7.jpg";